module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dropdown-menu dropdown-menu-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: _vm.$route.name,
        params: {
          language: 'en'
        }
      }
    }
  }, [_c('a', {
    staticClass: "dropdown-item"
  }, [_vm._v(" English")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: _vm.$route.name,
        params: {
          language: 'cn'
        }
      }
    }
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "lang": "zh-Hans"
    }
  }, [_vm._v("简体")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: _vm.$route.name,
        params: {
          language: 'tw'
        }
      }
    }
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "lang": "zh-Hant"
    }
  }, [_vm._v("繁體")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: _vm.$route.name,
        params: {
          language: 'vi'
        }
      }
    }
  }, [_c('a', {
    staticClass: "dropdown-item"
  }, [_vm._v(" Tiếng Việt")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: _vm.$route.name,
        params: {
          language: 'ms'
        }
      }
    }
  }, [_c('a', {
    staticClass: "dropdown-item"
  }, [_vm._v(" Melayu")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69bfb0a6"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DropDownLang.vue
// module id = 344
// module chunks = 0